module.exports = __webpack_public_path__ + "static/img-main-e8f91e82b557c9a076f34d7e4491dcdb.jpg";